import { useDispatch, useSelector } from 'react-redux';
import {
  TILING_TYPE,
} from '../../../../config/constant/unityConstants';
import {
  setCuratorLoader,
} from '../../../../redux/slicers/admin/curatorSlicer';
import {
  selectActiveTab,
  selectApplyTextureInProgress,
  selectMaterial,
  setActiveTab,
  setApplyTextureInProgress,
  TAB_NAME,
} from '../../../../redux/slicers/admin/curatorStylesSlicer';
import {
  selectDataByTilingType,
} from '../../../../redux/slicers/admin/curatorUnityObjectSlicer';
import { useUnityContext } from '../../../container/unityContainer';
import { getAppState } from '../../../../redux/store';
import { errorToast } from '../../../../helpers/toastHelper';
import { undoRedo } from '../UndoRedo/UndoRedo';
import { setCuratorNotSaved } from '../../../../pages/admin/curator/curatorState';
//import { captureException } from '@sentry/react';
import { isUserOnboarding } from '../../../gamificationTooltip/helpers';

export const useUnityMaterial = () => {
  const dispatch = useDispatch();
  const unity = useUnityContext();
  const activeTab = useSelector(selectActiveTab);
  const isOnboarding = isUserOnboarding();

  const applyMaterial = async ({ material, switchToProperties = false, skipHistory = false }) => {
    let alertTitle = 'material';

    if (isOnboarding && activeTab === TAB_NAME.TEXTURES) {
      alertTitle = 'texture';
    }

    if (selectApplyTextureInProgress(getAppState())) {
      errorToast('Please wait, previous texture is still in progress', {
        toastId: 'TEXTURE_APPLY_IN_PROGRESS',
      });
      return;
    }

    const prevTiling = selectDataByTilingType(getAppState(), TILING_TYPE.MATERIAL);
    if (prevTiling?.materialId === material.id) {
      errorToast(`This ${alertTitle} is already applied`);
      return;
    }

    if (!material.material_image && !material.file && !material.is_user_material_preset) {
      errorToast(`Unable to apply ${alertTitle}. ${alertTitle} details are missing`, {
        toastId: `MATERIAL_IMAGE_MISSING_${material.id}`,
      });
      return;
    }

    if (!skipHistory) {
      await undoRedo.objectProperties.applyMaterial({ material });
    }

    dispatch(setApplyTextureInProgress(true));
    dispatch(setCuratorLoader(false));
    dispatch(selectMaterial(material));
    try {
      await unity.materialModule.selectMaterial({ material });
    } catch (e) {
      console.error(e);
      //captureException(e);
      dispatch(setCuratorLoader(true));
      dispatch(setApplyTextureInProgress(false));
      errorToast(`Unable to apply ${alertTitle}. LF_2423488`, {
        toastId: `MATERIAL_APPLY_ERROR_${material.id}`,
      });

      if (!skipHistory) {
        undoRedo.removeLastEntry();
      }
      return;
    }

    if (switchToProperties) {
      dispatch(setActiveTab(TAB_NAME.PROPERTIES));
    }

    if (isOnboarding) {
      dispatch(setCuratorLoader(true));
    }
    setCuratorNotSaved();
  };

  return {
    applyMaterial,
  };
};
